import {customAxiosBE} from "../config";
import axios from "axios";
import {parsePaginationParams} from "../../utils/other";

export async function tripViewById(id) {
    return customAxiosBE.get(`/tripView/${id}`)
}

export async function getAllTripViewAPI(data) {
    const parsedParams = parsePaginationParams(data)
    return customAxiosBE.get(`/tripView?${parsedParams}`)
}

// export async function getAllTripsWithoutRateCardAPI(rateCardId) {
//     return customAxiosBE.get(`/tripView/tripsWithoutRateCard/${rateCardId}`)
// }

export const searchVisibleTripViewAPI = async (data, stationOperatorId, cancelToken) => {
    let response;
    const {
        lineName,
        licenceNumber,
        hasException,
        isMgsi,
        rateCardId,
        status,
        operatorName,
        dateTo,
        dateFrom,
        departureTime,
        departureTimeFromNSTimeID,
        onlyCurrentRateCard,
        stationId,
        depStationId,
        arrStationId,
        containedStationId,
        tripExceptionPeriodIds,
        isInformator
    } = data;

    const parsedParams = parsePaginationParams(data);

    const parsedStatus = status === "AKTIVAN" ? true : status === "PASIVAN" ? false : null;

    const requestBody = {
        status: parsedStatus,
        lineName,
        licenceNumber,
        hasException,
        isMgsi,
        rateCardId,
        operatorName,
        dateTo,
        dateFrom,
        departureTime,
        departureTimeFromNSTimeID,
        stationId,
        onlyCurrentRateCard,
        depStationId,
        arrStationId,
        containedStationId,
        tripExceptionPeriodIds,
        isInformator
    };

    await customAxiosBE
        .post(`/tripView/searchVisible?stationOperatorId=${stationOperatorId}&${parsedParams}`, requestBody, {
            cancelToken,
        })
        .then((r) => {
            response = r.data;
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                console.error("API call failed in searchVisibleTripViewAPI:", error);
            }
        });

    return response;
};

export const searchTripViewAPI = async (data, cancelToken) => {
    let response;
    const {
        lineName,
        licenceNumber,
        hasException,
        isMgsi,
        rateCardId,
        status,
        operatorName,
        dateTo,
        dateFrom,
        departureTime,
        departureTimeFromNSTimeID,
        onlyCurrentRateCard,
        stationId,
        depStationId,
        arrStationId,
        containedStationId,
        tripExceptionPeriodIds,
        isInformator
    } = data;

    const parsedParams = parsePaginationParams(data);

    const parsedStatus = status === "AKTIVAN" ? true : status === "PASIVAN" ? false : null;

    const requestBody = {
        status: parsedStatus,
        lineName,
        licenceNumber,
        hasException,
        isMgsi,
        rateCardId,
        operatorName,
        dateTo,
        dateFrom,
        departureTime,
        departureTimeFromNSTimeID,
        stationId,
        onlyCurrentRateCard,
        depStationId,
        arrStationId,
        containedStationId,
        tripExceptionPeriodIds,
        isInformator
    };

    await customAxiosBE
        .post(`/tripView/search?${parsedParams}`, requestBody, {
            cancelToken,
        })
        .then((r) => {
            response = r.data;
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                console.error("API call failed in searchTripViewAPI:", error);

            }
        });

    return response;
};
